import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=4dd85c2e&"
import script from "./AdminLayout.vue?vue&type=script&lang=ts&"
export * from "./AdminLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports